import { atomWithReset } from "jotai/utils";

export const integrationStatusModalAtom = atomWithReset<{
  visible: boolean;
  orderId: string | null;
}>({
  visible: false,
  orderId: null
});
